import type { RiskProfileSummaryResponse } from '../types/riskProfileSummary.types'

export interface RiskProfileSummaryRow {
  key: string
  label: string
  damageCost: number | null
  damageCostPc: number | null
  totalValue: number | null
  damageSeverityPc: number | null
  quantityExposedPc: number | null
}

export function mapSummaryResponseToRows(
  response: RiskProfileSummaryResponse,
): RiskProfileSummaryRow[] {
  const labelByKey = new Map(response.groups.map((group) => [group.key, group.label]))

  return response.group_totals.map((total) => {
    const damageCost = total.metrics['damage_cost']
    const damageSeverity = total.metrics['damage_severity']
    const quantity = total.metrics['quantity']

    return {
      key: total.group_key,
      label: labelByKey.get(total.group_key) ?? total.group_key,
      damageCost: damageCost?.value ?? null,
      damageCostPc: damageCost?.percent_value ?? null,
      totalValue: damageCost?.total_value ?? null,
      damageSeverityPc: damageSeverity?.percent_value ?? null,
      quantityExposedPc: quantity?.percent_value ?? null,
    }
  })
}
